import { render } from "./AdminPasswordChangePage.vue?vue&type=template&id=03aa83d8&ts=true"
import script from "./AdminPasswordChangePage.vue?vue&type=script&lang=ts"
export * from "./AdminPasswordChangePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
